






import Vue from 'vue'

export default Vue.extend({
	props: {
		trackId: String,
	},

	computed: {
		classes() {
			return `track${this.trackId}`
		},

		trackName() {
			return "Torekov - Båstad";
		}
	}
})
